import React from "react";
import "./BonusDetails_card.css";
import No_data from "../../Common/No_data/No_data";

function BonusDetails_card({ status = "received" }) {
  const cards = [
    {
      id: 1,
      amount: "₹4.78",
      title: "Washing code rebate",
      date: "2026-02-13 13:34:12",
      status: "Received",
    },
    {
      id: 2,
      amount: "₹4.78",
      title: "Daily rewards",
      date: "2026-02-13 13:34:12",
      status: "Received",
    },
    {
      id: 3,
      amount: "₹4.78",
      title: "Turnatable awards",
      date: "2026-02-13 13:34:12",
      status: "Received",
    },
    {
      id: 4,
      amount: "₹4.78",
      title: "Washing code rebate",
      date: "2026-02-13 13:34:12",
      status: "Received",
    },
  ];

  const filtered = cards.filter((c) => {
    if (status === "tobe") return c.status === "To be collected";
    if (status === "received") return c.status === "Received";
    if (status === "expired") return c.status === "Expired";
    return true;
  });

  return (
    <section className="Bonus_cards_holder">
      {filtered.length === 0 && <No_data />}
      {filtered.map((card) => (
        <div className="Bonus_card" key={card.id}>
          <div className="left">
            <span className="amount">
              <div className="img_holder">
                <img
                  className="star_img"
                  src="/assets/images/icons/star.png"
                  alt="star"
                />
              </div>
              {card.amount}
            </span>
            <span className="title">{card.title}</span>
            <span className="date">{card.date}</span>
          </div>
          <div className="right">
            <span className="status-label">{card.status}</span>
          </div>
        </div>
      ))}
    </section>
  );
}

export default BonusDetails_card;
